<div class="recent-matches-card">
  <header class="card-head">
    <h3>Recent Matches</h3>
    <button type="button" class="view-all" (click)="viewAll()">VIEW ALL →</button>
  </header>

  <div class="card-body">
    <ng-container *ngIf="!isLoading() && matches().length > 0">
      <div class="match-row clickable" *ngFor="let m of matches()" (click)="viewAll()">
        <div class="match-icon" [class.matched]="m.status === 'MATCHED'"
             [class.partial]="m.status === 'PARTIAL'"
             [class.failed]="m.status === 'FAILED'">
          <ng-container [ngSwitch]="m.status">
            <span *ngSwitchCase="'MATCHED'">✓</span>
            <span *ngSwitchCase="'PARTIAL'">!</span>
            <span *ngSwitchCase="'FAILED'">×</span>
          </ng-container>
        </div>
        <div class="match-text">
          <div class="match-name">{{ m.statusMessage }}</div>
          <div class="match-meta">{{ m.relativeTime }}</div>
        </div>
        <span class="match-status"
              [class.matched]="m.status === 'MATCHED'"
              [class.partial]="m.status === 'PARTIAL'"
              [class.failed]="m.status === 'FAILED'">{{ m.status }}</span>
      </div>
    </ng-container>

    <div class="empty-state" *ngIf="!isLoading() && matches().length === 0">
      <i class="bi bi-inbox"></i>
      <p>No recent imports yet</p>
    </div>

    <div class="loading-state" *ngIf="isLoading()">
      <div class="match-skeleton" *ngFor="let _ of [1,2,3,4]"></div>
    </div>
  </div>
</div>
